module.exports = __webpack_public_path__ + "img/1.2524c6be.jpg";